import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from '../components/enums'

export const raisedClaim = async (data: object) => {
  return axios.put(endpoints.claimRaised, data)
}

export const useRaisedClaim = () => {
  const queryClient = useQueryClient()
  return useMutation(raisedClaim, {
    onSuccess: () => {
      queryClient.invalidateQueries([ApiKey.incidents, ApiKey.list])
    },
  })
}
